export default __webpack_public_path__ + "./font/44accff03a92fde4beda4de42d88717d.eot";